import { render } from "./AlertTriangleYellow.vue?vue&type=template&id=7147890c"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/AlertTriangleYellow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7147890c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7147890c', __exports__)) {
    api.reload('7147890c', __exports__)
  }
  
  module.hot.accept("./AlertTriangleYellow.vue?vue&type=template&id=7147890c", () => {
    api.rerender('7147890c', render)
  })

}


export default __exports__